import React, { memo } from "react";
import Pagination from "react-bootstrap/Pagination";
import { useEffect, useState } from "react";

const PaginationComponent = ({ count, page, setPage = () => {} }) => {
  // Responsive pagination size using Bootstrap classes
  const [paginationSize, setPaginationSize] = useState("");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1092) {
        setPaginationSize("sm");
      } else {
        setPaginationSize("");
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const generatePages = () => {
    let items = [];
    const visiblePages = 2; // Number of page links around the current page
    const startPage = Math.max(page - visiblePages, 1);
    const endPage = Math.min(page + visiblePages, count);

    // Show first three pages
    for (let i = 1; i <= 3 && i <= count; i++) {
      items.push(
        <Pagination.Item key={i} active={i === page} onClick={() => setPage(i)}>
          {i}
        </Pagination.Item>
      );
    }

    // Show ellipsis if current page is far from the first few pages
    if (startPage > 4) {
      items.push(<Pagination.Ellipsis key="start-ellipsis" />);
    }

    // Show range of pages around the current page, but avoid repeating the first or last three
    for (
      let number = Math.max(4, startPage);
      number <= Math.min(count - 3, endPage);
      number++
    ) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === page}
          onClick={() => setPage(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    // Show ellipsis if current page is far from the last few pages
    if (endPage < count - 3) {
      items.push(<Pagination.Ellipsis key="end-ellipsis" />);
    }

    // Show last three pages
    for (let i = Math.max(count - 2, 4); i <= count; i++) {
      items.push(
        <Pagination.Item key={i} active={i === page} onClick={() => setPage(i)}>
          {i}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <div className="d-flex mt-4 justify-content-lg-end justify-content-center pagination-responsive">
      <Pagination size={paginationSize}>
        {/* Double arrow to go to the first page */}
        <Pagination.First onClick={() => setPage(1)} disabled={page === 1} />

        {/* Single arrow to go to the previous page */}
        <Pagination.Prev
          onClick={() => setPage(page - 1)}
          disabled={page === 1}
        />

        {/* Generate the numbered page items */}
        {generatePages()}

        {/* Single arrow to go to the next page */}
        <Pagination.Next
          onClick={() => setPage(page + 1)}
          disabled={page === count}
        />

        {/* Double arrow to go to the last page */}
        <Pagination.Last
          onClick={() => setPage(count)}
          disabled={page === count}
        />
      </Pagination>
    </div>
  );
};

export default memo(PaginationComponent);
